import { render, staticRenderFns } from "./System.vue?vue&type=template&id=65d8736e&scoped=true"
import script from "./System.vue?vue&type=script&lang=js"
export * from "./System.vue?vue&type=script&lang=js"
import style0 from "./System.vue?vue&type=style&index=0&id=65d8736e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d8736e",
  null
  
)

export default component.exports